import {
  FETCH_VIDEO_STORE_ITEMS_START,
  FETCH_VIDEO_STORE_ITEMS_SUCCESS,
  FETCH_VIDEO_STORE_ITEMS_FAILURE,
  FETCH_VIDEO_STORE_SUGGESTIONS_START,
  FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS,
  FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE,
  CHANGE_VIDEO_STORE_VISIBILITY_START,
  CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS,
  CHANGE_VIDEO_STORE_VISIBILITY_FAILURE,
  UPDATE_POST_LIKES,
  UPDATE_POST_BOOKMARK_STATUS,
  SET_HOME_POST,
  SUBSCRIBE_TO_PLAN_SUCCESS,
} from "../actions/ActionConstant";
import { 
  mergeListOfPosts, 
  modifyPostLike,
  modifyPostBookmarkStatus,
  replaceUpdatePost,
  sortPostsWithVideosFirst,
  sortPostFilesWithVideosFirst,
  modifyPostOnSubscribedToPerformer
} from "../../components/helper/Utils";

export const initialState = {
  items: {
    data: {
      posts: [],
      page: 0,
      limit: 15,
      total: 0,
      totalPages: 0,
    },
    loading: false,
    error: false,
    inputData: {},
  },
  suggestions: {
    data: {
      posts: [],
      suggested: false,
      page: 0,
      limit: 10,
      total: 0,
      totalPages: 0,
    },
    loading: false,
    error: false,
    inputData: {},
  },
  changeVisibility: {
    byPostId: {},
  },
};

const updatePostsIsHidden = (posts, postId, isHidden) => {
  const idStr = postId?.toString?.();
  if (!idStr) return posts || [];

  return (
    posts?.map((p) => {
      const pId = p?.post_id;
      if (pId?.toString?.() === idStr) {
        return { ...p, is_hidden: isHidden ? 1 : 0 };
      }
      return p;
    }) || []
  );
};

const VideoStoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VIDEO_STORE_ITEMS_START:
      return {
        ...state,
        items: {
          ...state.items,
          data:
            action.data && action.data.page === 0
              ? initialState.items.data
              : state.items.data,
          loading: true,
          error: false,
          inputData: action.data || {},
        },
        suggestions:
          action.data && action.data.page === 0
            ? initialState.suggestions
            : state.suggestions,
      };

    case FETCH_VIDEO_STORE_ITEMS_SUCCESS:
      const mergedPosts = mergeListOfPosts(
        state.items?.data.posts || [],
        action.data && action.data.posts ? action.data.posts : []
      );
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...action.data,
            posts: sortPostsWithVideosFirst(mergedPosts),
          },
          loading: false,
          error: false,
        },
      };

    case FETCH_VIDEO_STORE_ITEMS_FAILURE:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          error: action.error || true,
        },
      };

    case FETCH_VIDEO_STORE_SUGGESTIONS_START:
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          data:
            action.data && action.data.page === 0
              ? initialState.suggestions.data
              : state.suggestions.data,
          loading: true,
          error: false,
          inputData: action.data || {},
        },
      };

    case FETCH_VIDEO_STORE_SUGGESTIONS_SUCCESS:
      const sugPage =
        (action.data && typeof action.data.page === "number"
          ? action.data.page
          : state.suggestions?.inputData?.page) || 0;

      const nextSugPosts = action.data?.posts || [];
      const mergedSugPosts =
        sugPage === 0
          ? nextSugPosts
          : mergeListOfPosts(state.suggestions?.data?.posts || [], nextSugPosts);

      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          data: {
            ...action.data,
            posts: sortPostsWithVideosFirst(mergedSugPosts),
          },
          loading: false,
          error: false,
        },
      };

    case FETCH_VIDEO_STORE_SUGGESTIONS_FAILURE:
      return {
        ...state,
        suggestions: {
          ...state.suggestions,
          loading: false,
          error: action.error || true,
        },
      };

    case CHANGE_VIDEO_STORE_VISIBILITY_START:
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: updatePostsIsHidden(
              state.items?.data?.posts || [],
              action.data?.post_id,
              action.data?.is_hidden
            ),
          },
        },
        suggestions: {
          ...state.suggestions,
          data: {
            ...state.suggestions.data,
            posts: updatePostsIsHidden(
              state.suggestions?.data?.posts || [],
              action.data?.post_id,
              action.data?.is_hidden
            ),
          },
        },
        changeVisibility: {
          ...state.changeVisibility,
          byPostId: {
            ...(state.changeVisibility?.byPostId || {}),
            [action.data?.post_id]: {
              loading: true,
              error: false,
            },
          },
        },
      };

    case CHANGE_VIDEO_STORE_VISIBILITY_SUCCESS:
      return {
        ...state,
        changeVisibility: {
          ...state.changeVisibility,
          byPostId: {
            ...(state.changeVisibility?.byPostId || {}),
            [action.data?.post_id]: {
              loading: false,
              error: false,
            },
          },
        },
      };

    case CHANGE_VIDEO_STORE_VISIBILITY_FAILURE:
      // Rollback optimistic UI change if we have previous state
      const postId = action?.request?.post_id;
      const prev = action?.request?.previous_is_hidden;
      const hasPrev = typeof prev === "boolean";
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: hasPrev
              ? updatePostsIsHidden(state.items?.data?.posts || [], postId, prev)
              : state.items?.data?.posts,
          },
        },
        suggestions: {
          ...state.suggestions,
          data: {
            ...state.suggestions.data,
            posts: hasPrev
              ? updatePostsIsHidden(state.suggestions?.data?.posts || [], postId, prev)
              : state.suggestions?.data?.posts,
          },
        },
        changeVisibility: {
          ...state.changeVisibility,
          byPostId: {
            ...(state.changeVisibility?.byPostId || {}),
            [postId]: {
              loading: false,
              error: action.error || true,
            },
          },
        },
      };

    case UPDATE_POST_LIKES:
      const updatedPosts = modifyPostLike(state.items?.data?.posts || [], action.data);
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: sortPostsWithVideosFirst(updatedPosts),
          },
        },
      };

    case UPDATE_POST_BOOKMARK_STATUS:
      const bookmarkUpdatedPosts = modifyPostBookmarkStatus(
        state.items?.data?.posts || [],
        action.data
      );
      const bookmarkUpdatedSuggestionPosts = modifyPostBookmarkStatus(
        state.suggestions?.data?.posts || [],
        action.data
      );
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: sortPostsWithVideosFirst(bookmarkUpdatedPosts),
          },
        },
        suggestions: {
          ...state.suggestions,
          data: {
            ...state.suggestions.data,
            posts: sortPostsWithVideosFirst(bookmarkUpdatedSuggestionPosts),
          },
        },
      };

    case SET_HOME_POST:
      const updatedPost = sortPostFilesWithVideosFirst(action.data.post);
      const replacedPosts = replaceUpdatePost(
        state.items?.data?.posts || [],
        updatedPost
      );
      const replacedSuggestionPosts = replaceUpdatePost(
        state.suggestions?.data?.posts || [],
        updatedPost
      );
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: sortPostsWithVideosFirst(replacedPosts),
          },
        },
        suggestions: {
          ...state.suggestions,
          data: {
            ...state.suggestions.data,
            posts: sortPostsWithVideosFirst(replacedSuggestionPosts),
          },
        },
      };

    case SUBSCRIBE_TO_PLAN_SUCCESS:
      const subscribedPosts = modifyPostOnSubscribedToPerformer(
        state.items?.data?.posts || [],
        action.data
      );
      return {
        ...state,
        items: {
          ...state.items,
          data: {
            ...state.items.data,
            posts: sortPostsWithVideosFirst(subscribedPosts),
          },
        },
      };

    default:
      return state;
  }
};

export default VideoStoreReducer;


